import { render } from "./gybQrCode.vue?vue&type=template&id=85483784&scoped=true"
import script from "./gybQrCode.vue?vue&type=script&lang=js"
export * from "./gybQrCode.vue?vue&type=script&lang=js"

import "./gybQrCode.vue?vue&type=style&index=0&id=85483784&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85483784"]])

export default __exports__